export class MetaTagInput {
    id?: number;
    ogTitle?: string;
    ogDescription?: string;
    ogImage?: string;
    ogUrl?: string;
    keywords?: string;
}
